import React, { createContext, useState } from "react";

export const CartContext = createContext();

function CartContextProvider({ children }) {
  const [cartItems, setcartItems] = useState([]);

  return (
    <CartContext.Provider value={{ cartItems, setcartItems }}>
      {children}
    </CartContext.Provider>
  );
}

export default CartContextProvider;
